/**
 * Created by huangzhangshu on 2018/8/3
 */
import React, {Component} from 'react';
import {connect} from 'dva';
import moment from 'moment';
import styles from './index.less';
import {wrapImage} from '../../utils';
import Login from '../../components/Login';
import LoginForDark from '../../components/LoginForDark';
import PasswordResetModal from '../../components/PasswordReset/PasswordResetModal';

class LoginPage extends Component {

  state = {licenseHeight: 0}

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch({type: 'vadpLogin/updateStatus', payload: true});
    dispatch({type: 'vadpLogin/fetchLicense'});
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {licenseHeight} = this.state;
    const licenseDOM = document.getElementById('license');
    if (licenseDOM) {
      const clientHeight = licenseDOM.clientHeight;
      // eslint-disable-next-line react/no-did-update-set-state
      if (licenseHeight !== clientHeight) this.setState({licenseHeight: clientHeight});
    }
  }

  getChinese = (strValue) => { // eslint-disable-line
    if (strValue !== null && strValue !== '') {
      const reg = /[\u4e00-\u9fa5]/g;
      return strValue.match(reg).join('');
    }
    return '';
  }

  getMaxLicenseNameLength = () => {
    const {expireLicense = []} = this.props;
    let maxLength = 0;
    let maxCharLength = 0;
    let maxChineseLength = 0;
    for (const {name: {length}, name} of expireLicense) {
      const chineseName = this.getChinese(name);
      if (length > maxLength) {
        maxLength = length;
        maxChineseLength = chineseName.length;
        maxCharLength = length - chineseName.length;
      }
    }
    return {maxChineseLength: maxChineseLength + 2, maxCharLength};
  }


  renderLicense = () => {
    const {licenseHeight} = this.state;
    const {expireLicense = []} = this.props;
    const {maxChineseLength, maxCharLength} = this.getMaxLicenseNameLength();
    const textStyle = {width: (maxChineseLength * 16) + (maxCharLength * 7)};
    // const textStyle = {};
    // eslint-disable-next-line no-mixed-operators
    const licenseStyle = {top: (innerHeight - (innerWidth * 0.235)) / 2 - 16 - licenseHeight};
    if (!expireLicense || expireLicense.length === 0) return null;
    return (
      <div className={styles.license} style={licenseStyle} id="license">
        <span className={styles.licenseTitle}>您有系统模块许可将于近期失效，请及时申请新许可</span>
        <div className={styles.licenseScroll}>
          {expireLicense.map((license) => {
            const {name, date} = license;
            return (
              <span
                className={styles.licenseText}>
                <span
                  className={styles.licenseTextName}
                  style={textStyle}>{name}模块</span>
                <span
                  className={styles.licenseTextDate}>到期日: {moment(date, 'YYYY-MM-DD').format('YYYY年MM月DD日')}</span></span>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const {
      loginStatus, loginBackgroundImageLight, loginImageLight, titleCn,
      titleEn, companyLink, companyName, loginLogo, loginBackgroundRightLight,
      loginBackgroundRightDark, loginLogoLight, loading, theme,
      loginBackgroundImageDark, loginLogoDark, loginImageDark, dispatch, resetVisible,
    } = this.props;
    const loginProps = {
      dispatch,
      loginStatus,
      loading,
    }
    const lightImages = {
      logo: loginLogoLight,
      image: loginImageLight,
      background: loginBackgroundImageLight,
    };
    const darkImages = {
      logo: loginLogoDark,
      image: loginImageDark,
      background: loginBackgroundImageDark,
    };
    const isDark = theme !== 'light';
    const images = !isDark ? lightImages : darkImages;
    const backgroundRight = !isDark ? loginBackgroundRightLight : loginBackgroundRightDark;
    const license = this.renderLicense();
    return (
      <div
        className={styles.vadpLoginRoot}
        style={{
          background: `url(${wrapImage(`/static/images/${images.background}`)}) top no-repeat`,
          backgroundSize: 'cover',
        }}>
        <div className={styles.logoDiv}>
          <img className={styles.logo} src={wrapImage(`/static/images/${loginLogo}`)}/>
          <div className={styles.nameDiv}>
            <div className={styles.nameCn}>{titleCn}</div>
            <div className={styles.nameEn}>{titleEn}</div>
          </div>
        </div>
        <div className={styles.right}>
          <img className={styles.rightImage} src={wrapImage(`/static/images/${backgroundRight}`)} alt=""/>
        </div>
        <div className={styles.bottom}>
          <img style={{width: 'auto', height: 22, marginRight: 8}} src={wrapImage('/static/images/login-footer-logo.png')}/>
          <div className={styles.span}>{companyLink}</div>
          <div className={styles.company}>{companyName}</div>
        </div>
        {license}
        {isDark ? <LoginForDark {...loginProps}/> : <Login {...loginProps}/>}
        <PasswordResetModal visible={resetVisible}  {...this.props} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loginStatus: state.vadpLogin.loginStatus,
    loading: state.vadpLogin.loading,
    loginBackgroundImageLight: state.vadpLogin.loginBackgroundImageLight,
    loginLogoLight: state.vadpLogin.loginLogoLight,
    loginImageLight: state.vadpLogin.loginImageLight,
    loginBackgroundImageDark: state.vadpLogin.loginBackgroundImageDark,
    loginLogoDark: state.vadpLogin.loginLogoDark,
    loginImageDark: state.vadpLogin.loginImageDark,
    loginBackgroundRightLight: state.vadpLogin.loginBackgroundRightLight,
    loginBackgroundRightDark: state.vadpLogin.loginBackgroundRightDark,
    titleCn: state.vadpLogin.titleCn,
    titleEn: state.vadpLogin.titleEn,
    companyLink: state.vadpLogin.companyLink,
    companyName: state.vadpLogin.companyName,
    theme: state.vadpLogin.theme,
    loginLogo: state.vadpLogin.loginLogo,
    expireLicense: state.vadpLogin.expireLicense,
    resetVisible: state.resetPassword.resetVisible,
  };
}

export default connect(mapStateToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/routes/LoginPageForNew/index.js